module.exports = __webpack_public_path__ + "img/Emily_Cox.3e89f2f9.jpeg";